import { createAsyncThunk } from '@reduxjs/toolkit';
import { ChangeAuthMethodInterface, Enable2FAInterface } from './types';
import { changeAuthMethod, enable2FA, verify2FA } from '../../api/auth/service';

export const changeAuthMethodThunk = createAsyncThunk(
  'auth/changeMethod',
  async (credentials: ChangeAuthMethodInterface, thunkAPI) => {
    const response = await changeAuthMethod(credentials, thunkAPI);
    return response;
  }
);

export const enable2FAThunk = createAsyncThunk(
  'auth/enable2FA',
  async (credentials: Enable2FAInterface, thunkAPI) => {
    const response = await enable2FA(credentials, thunkAPI);
    return response;
  }
);

export const verify2FAThunk = createAsyncThunk(
  'auth/verify2FA',
  async ({ code, userId }: { code: string, userId: string }, thunkAPI) => {
    const response = await verify2FA({ code, userId }, thunkAPI);
    return response;
  }
); 